module.exports = __webpack_public_path__ + "img/finance.3cfd18c1.svg";